import { render } from "./Informing.vue?vue&type=template&id=2badb7f7"
import script from "./Informing.vue?vue&type=script&lang=js"
export * from "./Informing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__